import {payTypes} from './ShiftTable';

const dateFormat = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', year: 'numeric',
  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'});
const dateTime = value => {
  const date = value ? new Date(value) : null;
  if (!date || !Number.isFinite(date.getTime())) return '';
  const parts = Object.fromEntries(dateFormat.formatToParts(date).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
};
const cell = value => {
  let text = String(value ?? '');
  // Keep user-entered names as text when opened in a spreadsheet.
  if (/^\s*[=+\-@]|^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export const shiftsCsv = shifts => {
  const headers = ['Shift ID', 'Employee', 'Pay type', ...['Scheduled start', 'Scheduled end', 'Clock in',
    'Clock out', 'Approved start', 'Approved end'].map(label => `${label} (Europe/London)`)];
  const rows = shifts.map(shift => [shift.plandayShiftId ?? shift.shiftId ?? '',
    shift.employee?.replace(/^Planday employee (\d+)$/, 'Employee $1') || 'Unknown employee',
    payTypes[shift.payType] || payTypes.unknown,
    ...['startTime', 'endTime', 'clockInTime', 'clockOutTime', 'approvedStart', 'approvedEnd'].map(key => dateTime(shift[key]))]);
  return `\uFEFF${[headers, ...rows].map(row => row.map(cell).join(',')).join('\r\n')}`;
};

export const downloadShiftsCsv = site => {
  const url = URL.createObjectURL(new Blob([shiftsCsv(site.shifts || [])], {type: 'text/csv;charset=utf-8;'}));
  const link = document.createElement('a');
  link.href = url;
  link.download = `shifts-${(site.name || 'report').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'report'}.csv`;
  document.body.appendChild(link);
  try {link.click();} finally {link.remove(); URL.revokeObjectURL(url);}
};
